import * as i from 'types';

export const orderPaymentInfoSelector = (state: i.ReduxState) => state?.orders?.paymentInfo;
export const orderDataSelector = (state: i.ReduxState) => state?.orders?.data;
export const orderCreateLoading = (state: i.ReduxState) => state?.orders?.loading;
